import { render, staticRenderFns } from "./eventStatistics.vue?vue&type=template&id=8e255d86&scoped=true&"
import script from "./eventStatistics.vue?vue&type=script&lang=js&"
export * from "./eventStatistics.vue?vue&type=script&lang=js&"
import style0 from "./eventStatistics.vue?vue&type=style&index=0&id=8e255d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e255d86",
  null
  
)

export default component.exports